<template>
	<div class="Header">
        <div class="HeaderTop">
            <img class="LogoImg" src="/static/logoSystem.png?v=2" alt="" />
        </div>
        <div class="HeaderCont">
            <img class="HeaderBg" src="/static/bg.png" alt="" />
            <div class="HeaderLogin" v-if="">
                <div class="HeaderTit">{{Type =='DL'?'用户登录':Type =='MM'?'忘记密码':'免费注册'}}</div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-cascader class="Sele" size="medium" v-model="DataJson.system" :options="systemData" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
                    <!-- <el-select class="Sele" v-model="DataJson.system" placeholder="请选择系统" multiple>
                        <el-option v-for="item in systemData" :key="item.id" :label="item.system_name" :value="item.system_code"></el-option>
                    </el-select> -->
                </div>
                <div class="HeaderItem">
                    <el-input class="Val" :placeholder="Type !='ZC'?'账号':'账号为字母加数字'" v-model="DataJson.username"/></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-input class="Val" placeholder="姓名" v-model="DataJson.name" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC' || Type =='MM'">
                    <el-input class="Val" placeholder="手机号" v-model="DataJson.phone" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-input class="Val" placeholder="邮箱" v-model="DataJson.email" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-input class="Val" placeholder="工作单位" v-model="DataJson.work_unit" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-input class="Val" placeholder="科室" v-model="DataJson.department" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'">
                    <el-input class="Val" placeholder="职称" v-model="DataJson.title" /></el-input>
                </div>
                <div class="HeaderItem" v-if="Type !='ZC'">
                    <el-input class="Val" placeholder="请输入密码,初始密码123456" v-model="DataJson.password" show-password></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='MM'">
                    <el-input class="Val" placeholder="请确认密码" v-model="DataJson.sucpass" show-password></el-input>
                </div>
                <div class="HeaderItem" v-if="Type =='DL'">
                    <el-input class="Val" placeholder="请输入验证码" v-model="DataJson.code"></el-input>
                    <img class="ImgCode"  :src="ImgUrl" alt="" @click="GetImgCode" />
                </div>
                <div class="HeaderItem" v-if="Type =='ZC'||Type =='MM'">
                    <el-input class="Val" placeholder="请输入验证码" v-model="DataJson.code"></el-input>
                    <el-link class="Code" :class="{CodeH:TimeTxt!='发送验证码'}" :disabled="TimeTxt!='发送验证码'" @click="GetCode" :underline="false">{{TimeTxt}}</el-link>
                </div>
                <div class="HeaderBtn" @click="ToggleFn">{{Type =='DL'?'登录':Type =='MM'?'确认':'提交申请'}}</div>
                <div class="HeaderOther" v-if="AdminType">
                    <span @click="ToggleNav('MM')" v-if="Type!= 'MM'">忘记密码</span>
                    <span @click="ToggleNav('ZC')" v-if="Type!= 'ZC'">注册申请</span>
                    <span @click="ToggleNav('DL')" v-if="Type!= 'DL'">已有账号</span>
                </div>
            </div>
        </div>
        <el-dialog title="初次登录需要先修改密码" :visible.sync="PassBlon" width="20%" class="BorderRadius" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">新密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入新密码" v-model="DataJson.password" show-password></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">确认密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入确认密码" v-model="DataJson.sucpass" show-password></el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SetPass">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
	export default {
		data() {
			return {
                Type:"DL",
                AdminType:true,
                DataJson:{
                    system:[],
                    name:"",
                    username:"",
                    password:"",
                    sucpass:"",
                    phone:"",
                    email:"",
                    work_unit:"",
                    department:"",
                    title:"",
                    code:"",
                },
                systemData:[],
                ImgUrl:"",
                TimeTxt:"发送验证码",
                TimeNum:60,
                Timer:null,
                PassBlon:false,
			};
		},
        mounted() {
           this.AdminType = this.$route.name=="user"?true:false;
           console.log(this.AdminType)
           this.GetImgCode();
           if(this.AdminType){
               this.GetSystem();
           }
        },
		methods: {
            ToggleNav(n){
                this.Type = n;
                this.$Tools.ResetData(this.DataJson);
            },
			ToggleFn(ev) {
                if(this.Type == "DL"){this.loginSuc();}
                if(this.Type == "MM"){this.ResetPass();}
                if(this.Type == "ZC"){this.Register();}
			},
            loginSuc(){
                if(!this.DataJson.username){this.$message.error("请输入账号");return;}
                if( !this.DataJson.password){this.$message.error("请输入密码");return;}
                if(!this.DataJson.code){this.$message.error("请输入验证码");return;}
                var url = this.AdminType?'api/auth/login':'/admin/auth/login';
                this.$post(url,{
                    username:this.DataJson.username,
                    password:this.DataJson.password,
                    captcha:this.DataJson.code,
                }).then(res=>{
                    if(res){
                        sessionStorage.setItem('USER-TOKEN',res.data.token);
                        if(!this.AdminType){
                            this.$Tools.localData('g',1);
                            setTimeout(()=>{
                                this.$router.push({path: '/AdminCount'});
                            },50)
                        }else{
                            if(res.data.user_info.is_dl){
                                this.DataJson.password = "";
                                this.PassBlon = true;
                            }else{
                               var num = 0;
                               this.$Tools.localData('g',null);
                               sessionStorage.setItem('USER-Info',JSON.stringify(res.data));
                               var Arr = res.data.system_list;
                               if(!res.data.user_info.jianli_url
                               &&!res.data.user_info.work_unit
                               &&!res.data.user_info.position
                               &&!res.data.user_info.title
                               ){
                                   this.$Tools.localData('ExpertNum',1);
                               }
                               if(res.data.user_info.is_expert){
                                   Arr.push({icon:'icon-daibanshixiang1',system_name:"专家评审入口",path:"/ExpertIndex",system_code:'expert_portal',child:[]})
                               }
                               Arr.forEach(item=>{
                                   if(item){num+=1}
                                   if(item.child){num+=item.child.length}
                               })
                               sessionStorage.setItem("Nav",JSON.stringify(Arr))
                               if(num>1){
                                   setTimeout(()=>{
                                       this.$router.push({path: '/nav'});
                                   },50)
                               }
                               if(num==1){
                                   sessionStorage.setItem('SYSTEM-TOKEN',Arr[0].system_code);
                                   sessionStorage.setItem("SYSTEM-Data",JSON.stringify(Arr[0].child[0]))
                                   setTimeout(()=>{
                                       if(Arr[0].system_code == 'expert_portal'){
                                           this.$router.push({path:"/ExpertIndex"});
                                       }else{
                                           this.$router.push({path:"/ModelIndex"});
                                       }
                                   },50)
                               } 
                            }
                        }
                    }
                }).finally(error => {
                    this.GetImgCode();
                    this.DataJson.code="";
                })
            },
            ResetPass(){
                if(!this.DataJson.phone||
                !this.DataJson.username||
                !this.DataJson.password||
                !this.DataJson.sucpass||
                !this.DataJson.code
                ){this.$message.error("输入项不能为空");return;}
                this.$post('/api/auth/userWjPass',{
                    phone: this.DataJson.phone,
                    username:this.DataJson.username,
                    passwords:this.DataJson.password,
                    passwordss:this.DataJson.sucpass,
                    code:this.DataJson.code,    
                    "scene": "reset_password",
                }).then(res=>{
                    if(res){
                        this.$message.success("重置成功")
                        this.Type = "DL";
                        this.$Tools.ResetData(this.DataJson);
                    }
                })
            },
            Register(){
                this.$post('/api/auth/register',{
                    name: this.DataJson.name,
                    phone: this.DataJson.phone,
                    username:this.DataJson.username,
                    email:this.DataJson.email,
                    work_unit:this.DataJson.work_unit,
                    department:this.DataJson.department,
                    title:this.DataJson.title,
                    code:this.DataJson.code,    
                    system_sub_id:this.DataJson.system,
                    scene:"register",
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg)
                        this.Type = "DL";
                        this.$Tools.ResetData(this.DataJson);
                    }
                })
            },
            SetPass(){
                this.$post('/api/auth/userPass',{
                    password: "123456",
                    passwords:this.DataJson.password,
                    passwordss:this.DataJson.sucpass,
                }).then(res=>{
                    if(res){
                        this.PassBlon = false;
                        this.$message.success(res.msg);
                        this.Type = "DL";
                        var user = this.DataJson.username;
                        this.$Tools.ResetData(this.DataJson);
                        this.DataJson.username = user;
                    }
                })
            },
            GetSystem(){
                this.$get('/api/auth/getAll').then(res=>{
                    if(res){
                        this.systemData = res.data;
                    }
                })
            },
            GetImgCode(){
                var url = this.AdminType?'api/auth/captcha':'/admin/auth/captcha'
                this.$get(url).then(res=>{
                    if(res){
                        this.ImgUrl = res.data.img;
                    }
                })
            },
            GetCode(str){
            	var that = this;
                var str = this.Type == "ZC"?"register":"reset_password";
            	if(!(/^1[3456789]\d{9}$/).test(that.DataJson.phone)){
                    this.$message.error("手机号不正确 请重新输入")
            	}else if(this.TimeNum ==60){
            		this.$post('/common/sms/sendCode',{
            		    scene:str,
            		    phone:that.DataJson.phone,
            		},"POST").then((res)=>{
            		    if(res){
            		        that.$message.success(res.msg)
            		        that.Timer = setInterval(function(){
            		       	that.TimeNum--;
            		       	that.TimeTxt = that.TimeNum+"秒";
            		       	if(that.TimeNum == 0){
            		       		that.TimeNum = 60;
            		       		clearInterval(that.Timer)
            		       		that.TimeTxt = "发送验证码";
            		       	}
            		       },1000) 
            		    }
            		})
            	}
            },
            
		}
	}
</script>

<style scoped>
	.HeaderTop{
	    /* background: #095b95; */
	    padding:0 20px;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
        margin-bottom:0 ;
    }
    .LogoImg{
        width: 550px;
        padding: 5px 0;
    }
    .HeaderCont{
        position: relative;
    }
    .HeaderBg{
        width: 100%;
    }
    .HeaderLogin{
        position: absolute;
        top: 50%;
        right: 10%;
        transform: translate(0,-50%);
        width: 400px;
        padding: 20px;
        border-radius: 20px;
        background: #fff;
        border: 1px solid #ddd;
    }
    .HeaderTit{
        text-align: center;
        font-weight: 700;
        font-size: 24px;
        color: #2c2c2c;
        margin-bottom: 20px;
        padding: 15px 0;
    }
    .HeaderItem{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 45px 20px;
        position: relative;
    }
    .HeaderItem .Val{
        background: #f8f8f8;
        flex: 1;
        border: 0 solid #ddd;
    }
    .HeaderItem .Sele{
        flex: 1;
        border: 0 solid #ddd;
        border-radius: 10px;
    }
    .HeaderItem .Code{
        color: #095b95;
        font-weight: 700;
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translate(0,-50%);
    }
    .HeaderItem .ImgCode{
        width: 120px;
        /* color: #fff; */
        /* font-size: 14px; */
        text-align: center;
        /* padding: 12px 0; */
        border-radius: 5px;
    }
    .HeaderBtn{
        margin: 0 45px;
        padding: 12px 10px;
        text-align: center;
        background: #095b95;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
    }
    .HeaderOther{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
    }
    .HeaderOther span{
        color:#6f6f6f;
        padding: 0 10px;
        cursor: pointer;
    }
    .HeaderOther span:last-child{
      border-left:2px solid #ededed;  
    }
    
</style>